import { Injectable } from '@angular/core'
import { User } from '../interfaces/user.interface'
import * as CryptoJS from 'crypto-js'

@Injectable({
  providedIn: 'root',
})
export class AvatarService {


  /**
   * Get Gravatar URL for email
   */
  getGravatarUrl (email: string, size: number = 80): string {
    const trimmedEmail = email.trim().toLowerCase()
    const hash = this.md5(trimmedEmail)
    return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=404`
  }

  /**
   * Get user initials from first and last name
   */
  getUserInitials (user: User): string {
    const firstInitial = user.first_name?.charAt(0)?.toUpperCase() || ''
    const lastInitial = user.last_name?.charAt(0)?.toUpperCase() || ''
    return `${firstInitial}${lastInitial}` ||
      user.email?.charAt(0)?.toUpperCase() || 'U'
  }

  /**
   * The user's own uploaded photo first (CC 05/10/2026), then Gravatar; the avatar component
   * falls back to initials when neither loads.
   */
  getAvatarUrl (user: User, size: number = 80): string {
    const own = user.profile?.avatar?.trim()
    if (own) return own
    return this.getGravatarUrl(user.email, size)
  }

  /**
   * Get background color for initials based on user email
   */
  getInitialsBackgroundColor (email: string): string {
    const colors = [
      '#1f2937', // gray-800
      '#7c3aed', // violet-600
      '#2563eb', // blue-600
      '#059669', // emerald-600
      '#d97706', // amber-600
      '#dc2626', // red-600
      '#c2410c', // orange-600
      '#9333ea', // purple-600
    ]

    let hash = 0
    for (let i = 0; i < email.length; i++) {
      hash = email.charCodeAt(i) + ((hash << 5) - hash)
    }

    return colors[Math.abs(hash) % colors.length]
  }

  /**
   * Generate MD5 hash for email
   */
  private md5 (input: string): string {
    return CryptoJS.MD5(input).toString()
  }
}
